<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button class="breadcrumb-back" @click="$router && $router.back ? $router.back() : window.history.back()">返回</button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.belong_cn }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.schoolname }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">校友中心公告详情</span>
        </div>

        <!-- 课务详情 -->
        <div class="courseware-detail">
          <div class="courseware-header">
            <h1 class="courseware-title">《{{ data.title || '--' }}》</h1>
            <p class="courseware-time">发布时间：{{ data.inputtime || '--' }}</p>
          </div>

          <div class="courseware-content">
            <div v-html="data.content"></div>
          </div>
        </div>
      </div>

      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
      </div>
    </div>
  </div>
</template>

<script>
import sign from '@/auth/sign'
// import url from '@/axios/url'
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import { getAlumnsNoticeDetail, getEduDetails } from '@/axios/education'

export default {
  name: 'TextCourseware',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter
  },
  data () {
    return {
      appid: 'wzwebapp',
      id: parseInt(this.$route.query.id),
      type: parseInt(this.$route.query.type),
      data: {},
      guidInfo: {
        belong_cn: '',
        schoolname: ''
      }
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      getAlumnsNoticeDetail(oneParams).then(res => {
        if (res.data.code === 202) {
          this.$message({ type: 'warning', message: '请先登录' })
        } else if (res.data.code === 201 || res.data.code === 401) {
          this.$message({ type: 'error', message: res.data.msg })
        } else if (res.data.code === 200) {
          this.data = res.data.data
          // 获取信息
          this.getguidInfo()
        }
      })
    },
    getguidInfo () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.data.school_id,
        type: this.type
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.guidInfo = {
            belong_cn: data.belong_cn || '',
            schoolname: data.schoolname || ''
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #F9F9F9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
}
.breadcrumb-back:hover {
  background: #f2f2f2;
  border-color: #ccc;
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #EF8432;
  font-weight: bold;
}

/* 课务详情样式 */
.courseware-detail {
  background: #fff;
  border-radius: 6px;
}
.courseware-header {
  margin-bottom: 20px;
  background: url('../../assets/images/title-bg.png') no-repeat center center;
  background-size: cover;
  padding: 20px;
}
.courseware-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 10px;
  font-weight: normal;
}
.courseware-time {
  color: #888;
  font-size: 14px;
}
.courseware-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/schoolCenterNoticeInfo.vue